export default {
  steps: {
    policyholderDetails: 'Policyholder Details',
    policyAndProfessionInfo: 'Policy & Profession Info',
    declarationsDetails: 'Declarations Details',
    quoteList: 'Quote List',
    summaryAndPayment: 'Summary & Payment',
  },
} as const
